import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { totalPax } from '../../../../../redux/currentSearch/selectors';
import { HeaderText } from './HeaderText';

export const HeaderPax = ({ pax }) => !!pax && (
    <span>
        <HeaderText text={pax.toString()} />
        <span className='odf-icon odf-icon-pax odf-space-outer-left-xs' />
    </span>
);

HeaderPax.propTypes = {
    pax: PropTypes.number,
};

HeaderPax.defaultProps = {
    pax: 1,
};

const mapStateToProps = (state) => ({
    pax: totalPax(state),
});

export const ConnectedHeaderPax = connect(mapStateToProps)(HeaderPax);
